// extracted by mini-css-extract-plugin
export default {"root":"IconRadio_root__yzmqX","checked":"IconRadio_checked__Nv0VU"};